import { orchestrator } from 'satcheljs';
import { logServiceCallForDiagnostics } from '../actions/publicActions';
import insertServiceCall from '../mutators/insertServiceCall';
import ensureLoggerInitialized from '../utils/initializeLogger';
import { now } from 'owa-datetime';
import getStore from '../store/store';
import { maxServiceCalls } from '../constants';
import removeServiceCall from '../mutators/removeServiceCall';

orchestrator(logServiceCallForDiagnostics, actionMessage => {
    const { serviceCalls } = getStore();

    if (serviceCalls.length == maxServiceCalls) {
        // if we already have the maxServiceCalls, then remove the first
        removeServiceCall();
    }

    ensureLoggerInitialized();
    if (!actionMessage.serviceCall.start) {
        // If start is not passed, then assume that time of calling the log is the approximate time of request made
        actionMessage.serviceCall.start = now();
    }
    insertServiceCall(actionMessage.serviceCall);
});
